<template>
  <div class="search-dropdown-modal-container" v-show="active" ref="main">
    <div class="search-dropdown-modal-content">
      <ul v-if="isFetching" class="loading-list">
        <li v-for="index in 5" class="loading-bar-wrapper">
          <div class="loading-bar"></div>
        </li>
      </ul>
      <ul v-else class="keywords-list">
        <li v-for="(keyword, idx) in displayKeywords" :class="{ selected: selectedIndex === idx }">
          <a 
            @click.prevent="onSelectKeywords(keyword)" 
            @mouseover="onMouseOver(keyword, idx)"
          >
            {{ autocompleteTag(keyword) }} {{ keyword.suggestionWord }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import IconBase from '@/components/IconBase';
import IconBuilding from '@/components/Icons/IconBuilding';
import IconStreet from '@/components/Icons/IconStreet';
import IconSales from '@/components/Icons/IconSales';
import IconStockId from '@/components/Icons/IconStockId';
import IconCurrentInput from '@/components/Icons/IconCurrentInput';
import IconPlaza from '@/components/Icons/IconPlaza';
import ListMixins from '@/mixins/autocomplete';

export default {
  mixins: [ListMixins],
  components: {
    IconBase,
    IconBuilding,
    IconStreet,
    IconSales,
    IconStockId,
    IconCurrentInput,
    IconPlaza,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
    },
    userInput: {
      type: String,
    },
  },
  data() {
    return {
      selectedIndex: 0,
    };
  },
  created() {
    document.addEventListener('keydown', this.onKey);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKey);
  },
  computed: {
    ...mapState('stocksAutocompleteSearch', [
      'isFetching',
      'keywords',
    ]),
    displayKeywords() {
      let freetext = {
        type: 'free_text',
        suggestionWord: this.userInput,
        value: this.userInput,
        ics: '',
      };
      
      if (this.userInput) {
        return [freetext, ...this.keywords];
      }
      return [...this.keywords];
    },
  },
  watch: {
    active(isActive) {
      if (isActive) {
        document.addEventListener('click', this.checkOutFocus);
      } else {
        document.removeEventListener('click', this.checkOutFocus);
      }
    },
    keywords() {
      this.selectedIndex = 0;
    },
    displayKeywords() {
      this.$nextTick(() => {
        if (this.$i18n.locale === 'gb') {
          window.changeToGb();
        }
      });
    },
  },
  methods: {
    ...mapActions('stocksAutocompleteSearch', [
      'addKeyword',
    ]),
    onKey(evt) {
      const keyName = evt.key;
      if (keyName === 'ArrowDown' && this.selectedIndex + 1 < this.displayKeywords.length) {
        this.selectedIndex += 1;
      } else if (keyName === 'ArrowUp' && this.selectedIndex > 0) {
        this.selectedIndex -= 1;
      } else if (keyName === 'Enter' && this.displayKeywords.length > 0) {
        this.onSelectKeywords(this.displayKeywords[this.selectedIndex]);
      }
    },
    onMouseOver(keyword, index) {
      this.selectedIndex = index;
    },
    onSelectKeywords(keyword) {
      this.addKeyword(keyword);
      this.$emit('select-keyword', keyword);
      this.selectedIndex = 0;
    },
    checkOutFocus(evt) {
      if (!this.$refs.main || !this.$refs.main.contains(evt.target)) {
        this.$emit('close');
      }
    },
  },
};
</script>

<style scoped>
.search-dropdown-modal-container {
  position: relative;
  z-index: 459;
}

.search-dropdown-modal-content {
  width: 100%;
  position: absolute;
  background: #fff;
  margin-top: -1px;
  z-index: 459;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
  clip-path: inset(0 -2px -2px -2px);
}

.keywords-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.keywords-list li a {
  color: #000000;
  font-size: 16px;
  width: 100%;
  display: block;
  padding: 8px 20px;
  text-decoration: none;
  cursor: pointer;
}

.keywords-list li a .keyword-type-icon {
  height: 16px;
}

.keywords-list li.selected {
  background: #7CCFEB;
}

.keywords-list li.selected a {
  color: #ffffff;
}

.keywords-list li.selected a .keyword-type-icon {
  fill: #ffffff;
}

.loading-list {
  list-style: none;
  padding: 0;
}

.loading-list .loading-bar-wrapper {
  height: 38px;
  padding: 10px 20px;
}

.keywords-list li:last-child {
  margin-bottom: 8px;
}

@keyframes moving-gradient {
  0% { background-position: left bottom; }
  100% { background-position: right bottom; }
}

.loading-list .loading-bar-wrapper .loading-bar {
  height: 100%;
  width: 70%;

  background: linear-gradient(to right, #c9c9c9 0%,#c9c9c9 40%,#d6d6d6 50%,#c9c9c9 60%,#c9c9c9 100%) repeat;
  background-size: 50% 100%;
  animation-name: moving-gradient;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
</style>
